import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEOHead from './SEOHead';
import Header from './Header';
import Footer from './Footer';
import { useDarkMode } from '../contexts/DarkModeContext';

export default function NotFound() {
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate();

  // Track 404 errors for analytics
  useEffect(() => {
    // Track 404 error for analytics (if you have analytics set up)
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: '404 - Page Not Found',
        page_location: window.location.href
      });
    }
  }, []);

  return (
    <div className={`min-h-screen flex flex-col transition-all duration-500 ${
      isDarkMode ? 'bg-[#0f0f0f]' : 'bg-white'
    }`}>
      <SEOHead
        title="404 - Page Not Found | YTProud"
        description="The page you're looking for doesn't exist. Return to YTProud's homepage or contact our support team."
        noindex={true}
        nofollow={true}
        canonical="https://ytproud.com/404"
        ogTitle="404 - Page Not Found | YTProud"
        ogDescription="The page you're looking for doesn't exist. Return to YTProud's homepage or contact our support team."
        twitterTitle="404 - Page Not Found | YTProud"
        twitterDescription="The page you're looking for doesn't exist. Return to YTProud's homepage or contact our support team."
        schemaJsonLd={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "404 - Page Not Found",
          "description": "The page you're looking for doesn't exist",
          "url": "https://ytproud.com/404",
          "mainEntity": {
            "@type": "Organization",
            "name": "YTProud",
            "url": "https://ytproud.com"
          }
        }}
      />

      <Header />
      <main className="flex-1 flex flex-col items-center justify-center mt-44 mb-44" role="main">
        <h1 className={`text-[100px] font-extrabold mb-4 transition-colors duration-300 ${
          isDarkMode ? 'text-white' : 'text-red-600'
        }`} aria-label="Error 404">404</h1>
        <p className={`text-lg font-bold mb-8 uppercase text-center max-w-2xl transition-colors duration-300 ${
          isDarkMode ? 'text-white' : 'text-red-600'
        }`}>
          WE ARE SORRY, BUT THE PAGE YOU REQUESTED WAS NOT FOUND!
        </p>
        <div className="flex gap-6" role="group" aria-label="Navigation options">
          <button
            className={`font-bold px-10 py-4 rounded-xl text-lg transition-all duration-300 focus:ring-2 focus:ring-red-500 focus:ring-offset-2 ${
              isDarkMode 
                ? 'bg-gradient-to-r from-red-600 to-red-700 text-white hover:from-red-700 hover:to-red-800 hover:shadow-lg hover:shadow-red-500/25' 
                : 'bg-red-600 text-white hover:bg-red-700'
            }`}
            onClick={() => navigate('/')}
            aria-label="Go to homepage"
          >
            GO HOME
          </button>
          <button
            className={`border-2 font-bold px-10 py-4 rounded-xl text-lg transition-all duration-300 focus:ring-2 focus:ring-red-500 focus:ring-offset-2 ${
              isDarkMode 
                ? 'border-red-400 text-red-400 bg-transparent hover:bg-red-400/10 hover:border-red-300 hover:text-red-300' 
                : 'border-red-600 text-red-600 bg-white hover:bg-red-50'
            }`}
            onClick={() => navigate('/contact')}
            aria-label="Contact support team"
          >
            CONTACT US
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
} 